import { createFileRoute } from '@tanstack/react-router';

import { transcriptSearchSchema } from 'containers/Transcript/utils/transcriptSearch';

/** The transcript of a booking that is not a study. A study shows it in its results. */
export const Route = createFileRoute('/studies/$studyId/transcripts/$videoCode')({
  validateSearch: search => transcriptSearchSchema.parse(search),
});
